import React from 'react';
import { PillTabs } from '@ui/PillTabs';

const tabs = ['all projects', 'my projects'] as const;
export type ProjectListTab = (typeof tabs)[number];

const TAB_LABELS: Record<ProjectListTab, string> = {
  'all projects': 'All projects',
  'my projects': 'My projects',
};

export const ProjectListFilter = ({
  selectedTab,
  onChange,
}: {
  selectedTab: ProjectListTab;
  onChange: (tab: ProjectListTab) => void;
}) => {
  return (
    <PillTabs
      tabs={tabs}
      value={selectedTab}
      onChange={onChange}
      labels={TAB_LABELS}
    />
  );
};
